import SystemManagementMutationTypes from './SystemManagementMutationTypes';

const SystemManagementMutations = {
  [SystemManagementMutationTypes.UPDATE_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [SystemManagementMutationTypes.UPDATE_SELECTED_SYSTEMS](state, selectedSystems) {
    state.selectedSystems = selectedSystems;
  },
};

export default SystemManagementMutations;
